import { render } from "./AnimatedCounter.vue?vue&type=template&id=5fa79480"
import script from "./AnimatedCounter.vue?vue&type=script&lang=js"
export * from "./AnimatedCounter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__